/* =========================================================================================
	Description: danh sách các enum dùng chung cho toàn hệ thống
	Author: DNThang
	CreatedDate: 02.07.2019
=========================================================================================:*/
import errorMisaId from './enumErrorMisaId';
import order from './enumOrder';

export const MSEnum = {
	fontSize: {
		fontSizeBody: 13
	},
	/**
	 * Các kiểu dữ liệu (maping với bảng DBOption dùng để parse dữ liệu)
	 * CreatedBy DNThang - 29.11.2019
	 */
	DataType: {
		/**
		 * Không xác định
		 */
		None: 0,
		String: 1,
		Boolean: 2,
		DateTime: 3,
		/**
		 * Dữ liệu integer
		 */
		Number: 4,
		Decimal: 5,
		Guid: 10
	},
	/**
	 * Các kiểu định dạng của MISA
	 * created by hoant 05.09.2019
	 * DNThang - 09.09.2019: Sửa tên từ EnumNumericType thành FormatType (và cho giá trị None = 0)
	 * NVLam - 16/09/2019: Thêm các kiểu dữ liệu khác ngoài số
	 */
	FormatType: {
		/// <summary>
		/// Loại mà không xử lý gì cả
		/// </summary>
		/// <remarks></remarks>
		None: 0,
		///Định dạng cho tiền hạch toán
		///Đơn giá
		UnitPrice: 1,
		///Thành tiền quy đổi
		Amount: 2,
		///-----------------------------------
		///Hệ số, Tỷ lệ
		Rate: 3,
		///Tỷ giá
		ExchangeRate: 4,
		///Định dạng cho tiền ngoai te
		///Đơn giá
		UnitPriceOC: 5,
		///Thành tiền nguyên tệ
		AmountOC: 6,
		///Hệ số, tỷ lệ phân bổ
		Allocation: 7,
		///-----------------------------------
		///Số lượng
		QuantityConvert: 8,
		//Số công
		WorkDay: 10,
		///Số lượng
		Quantity: 11,
		//Kiểu chữ
		Text: 12,
		//Kiểu tích chọn
		Checkbox: 13,
		//Kiểu ngày tháng
		Date: 14,
		//Kiểu danh sách
		List: 15,
		//Kiểu thời gian
		Time: 16,
		// Join mảng theo dấu ;
		Join: 17,
		//Group Item
		GroupItem: 18,
		//Kiểu ngày/tháng/năm có giờ
		DateTime: 19,
		//Kiểu số không có định dạng sau dấu phẩy
		Number: 20,
		//Định dạng dữ liệu kỳ tính thuế
		TaxPeriod: 21,
		//Định dạng status thuế
		TaxStatus: 22,
		//Định dạng dữ liệu html
		Html: 99,
		//Kiểu enum
		Enum: 100
	},
	/**
	 * Trạng thái làm việc của form
	 * CreatedBy DNThang - 25.12.2019
	 */
	FormState: {
		/**
		 * Mode View
		 */
		View: 0,
		/**
		 * Thêm
		 */
		Add: 1,
		/**
		 * Sửa
		 */
		Edit: 2,
		/**
		 * Nhân bản
		 */
		Duplicate: 3,
		/**
		 * Thêm nhanh
		 */
		QuickAdd: 4,
		// Thêm bản ghi với dữ liệu có từ các bên tích hợp
		AddWidthData: 5
	},

	/**
	 * Các chế độ editmode
	 * Mapping với server side
	 */
	ModelState: {
		/**
		 * Mode View
		 */
		None: 0,
		/**
		 * Thêm
		 */
		Insert: 1,
		/**
		 * Sửa
		 */
		Update: 2,
		/**
		 * Xóa
		 */
		Delete: 3,
		/**
		 * Nhân bản
		 */
		Duplicate: 4,
		/**
		 * Thêm nhanh
		 */
		QuickAdd: 5,
		/**
		 * Nhập khẩu
		 */
		Import: 6
	},

	//Hành động save
	SaveMode: {
		Save: 0,
		SaveNew: 1
	},
	//UserNaem đăng nhập là số điện thoại hay email
	UserNameType: {
		None: 0,
		Email: 1,
		Phone: 2
	},
	//Loại xác thức 2 lớp qua phương thức nào
	TypeVerifyTwoFactor: {
		Phone: 1,
		Email: 2,
		App: 3
	},
	Step: {
		StepOne: 1,
		StepTwo: 2,
		StepThree: 3,
		StepFour: 4
	},
	// loại đăng ký/ ngừng/ thay đổi / nộp / khai
	SubmissionType: {
		//Không thuộc loại nào
		None: 0,
		//Đăng ký sử dụng dịch vụ khai thuế TVAN
		Dec_RegistrationServiceTVAN: 1,
		//Đăng ký ngừng sử dụng dịch vụ khai thuế TVAN
		Dec_StopServiceTVAN: 2,
		//Đăng ký tờ khai nộp qua mạng
		Dec_RegistrationDeclare: 3,
		//Đăng ký ngừng nộp tờ khai qua mạng
		Dec_StopDeclare: 4,
		//Thay đổi, bổ sung thông tin dịch vụ khai thuế
		Dec_ChangeServiceTVAN: 5,
		//Đăng ký sử dụng dịch vụ nộp thuế TVAN
		Pay_RegistrationServiceTVAN: 6,
		//Đăng ký ngừng sử dụng dịch vụ nộp thuế TVAN
		Pay_StopServiceTVAN: 7,
		//Đăng ký thay đổi, bổ sung thông tin dịch vụ nộp thuế
		Pay_ChangeInfoService: 8,
		//Đăng ký thay đổi, bổ sung thông tin ngân hàng dịch vụ nộp thuế
		Pay_ChangeBankService: 9,
		//Ngừng ngân hàng
		Pay_StopBank: 10,
		//Giấy nộp tiền,
		Pay_TaxPaper: 11,
		//Giấy nộp tiền nộp thay
		Pay_TaxPaperFiled: 12,
		//Nộp tờ khai thuế
		Dec_TaxReturn: 13,
		//Nộp tờ khai phụ lục
		Dec_TaxReturnAdditional: 14,
		//Đăng ký tờ khai vãng lai
		Dec_RegistrationDeclareHaunt: 15,
		//Đăng ký ngừng tờ khai vãng lai
		Dec_StopDeclareHaunt: 16
	},
	// vùng ký của tờ khai nộp thuế
	SignLocation: {
		Pay_RegistrationServiceTVAN_Sign: 'DKY_NTHUE_NH',
		Pay_StopServiceTVAN_Sign: 'TBAO_NGUNG',
		Pay_ChangeInfoService_Sign: 'TDOI_TKHOAN',
		Pay_StopBank_Sign: 'TBAO_NGUNG',
		ChungTu03001_Sign: 'CHUNGTU',
		Rm_Pay_RegistrationServiceTVAN_Sign:
			'//DATA/BODY/ROW/GIAODICH/DKY_NTHUE_NH',
		Rm_Pay_StopServiceTVAN_Sign: '//DATA/BODY/ROW/GIAODICH/TBAO_NGUNG',
		Rm_Pay_ChangeInfoService_Sign: '//DATA/BODY/ROW/GIAODICH/TDOI_TKHOAN',
		Rm_Pay_StopBank_Sign: '//DATA/BODY/ROW/GIAODICH/TBAO_NGUNG',
		Rm_ChungTu03001_Sign: '//DATA/BODY/ROW/GIAODICH/CHUNGTU',
		RmHs_Pay_RegistrationServiceTVAN_Sign:
			'//DATA/BODY/ROW/GIAODICH/DKY_NTHUE_NH/DKY_NTHUE',
		RmHs_Pay_StopServiceTVAN_Sign:
			'//DATA/BODY/ROW/GIAODICH/TBAO_NGUNG/TBAO_NGUNG_NT',
		RmHs_Pay_ChangeInfoService_Sign:
			'//DATA/BODY/ROW/GIAODICH/TDOI_TKHOAN/TDOI_TKHOAN_NT',
		RmHs_Pay_StopBank_Sign:
			'//DATA/BODY/ROW/GIAODICH/TBAO_NGUNG/TBAO_NGUNG_NT',
		RmHs_ChungTu03001_Sign: '//DATA/BODY/ROW/GIAODICH/CHUNGTU/NDUNG_CTU_NH'
	},
	//Chức vụ
	Role: {
		Admin: 1,
		User: 2
	},
	//Enum Event
	Event: {
		None: 0,
		Add: 1,
		Edit: 2,
		Delete: 3,
		ShowMess: 4,
		Download: 5,
		View: 6,
		Duplicate: 7,
		Accept: 8,
		Close: 9,
		ViewPDF: 10,
		AddTaxPaper: 11
	},
	PaymentStatus: {
		All: 7,
		PaymentWait: 0,
		PaymentSuccess: 3,
		PaymentCancel: 4
	},
	// Enum cho trạng thái của dịch vụ đăng ký
	Status: {
		All: 0,
		// gửi lên MISA
		SendToMisa: 1,
		// gửi lên TCT
		SendToTCT: 2,
		// TCT chấp nhận
		TCTAccept: 3,
		// TCT từ chối
		TCTReject: 4,
		// Gửi TCT thất bại
		Error: 5
	},
	/**
	 * Trạng thái giao dịch của khai thuế
	 */
	TaxReturnStatusEnum: {
		All: 0,
		// gửi lên MISA
		SendToMISA: 1,
		// gửi lên TCT
		SendToTCT: 2,
		// TCT tiếp nhận
		TCTReceive: 3,
		// TCT không tiếp nhận
		TCTNotReceive: 4,
		//TCT chấp nhận, Quyết định hoàn (28, 29)
		TCTAccept: 5,
		//TCT từ chối
		TCTReject: 6,
		// Gửi TCT thất bại
		Error: 7,
		// TCT đang xử lý hoàn thuế
		TCTProcessingRefund: 8,
		////TCT chấp nhận hủy cho hoàn thuế (46)
		Cancel: 9,
		//TCT yêu cầu giải trình, bổ sung hoàn thuế (23)
		RequestJustify: 10,
		//NNT đã gửi giải trình, bổ sung hoàn thuế => Khi nộp lại phụ lục Click Hoàn thành giải trình bổ sung => Đổi trạng thái sang 10
		Justified: 11,
		//TCT tạm dừng giải quyết hoàn thuế (26)
		Paused: 12
	},
	TaxReturnStatusEnum2: {
		All: '',
		// gửi lên MISA
		SendToMISA: 1,
		// gửi lên TCT
		SendToTCT: 2,
		// TCT tiếp nhận
		TCTReceive: 3,
		// TCT không tiếp nhận
		TCTNotReceive: 4,
		//TCT chấp nhận, Quyết định hoàn (28, 29)
		TCTAccept: 5,
		//TCT từ chối
		TCTReject: 6,
		// Gửi TCT thất bại
		Error: 7,
		//TCT đang xử lý hoàn thuế
		TCTProcessingRefund: 8,
		////TCT chấp nhận hủy cho hoàn thuế (46)
		Cancel: 9,
		//TCT yêu cầu giải trình, bổ sung hoàn thuế (23)
		RequestJustify: 10,
		//NNT đã gửi giải trình, bổ sung hoàn thuế => Khi nộp lại phụ lục Click Hoàn thành giải trình bổ sung => Đổi trạng thái sang 10
		Justified: 11,
		//TCT tạm dừng giải quyết hoàn thuế (26)
		Paused: 12
	},
	/**
	 * Trạng thái giao dịch của nộp thuế
	 */
	MTaxStatus: {
		Draft: 0,
		/// Gửi lên MISA
		SendToMISA: 1,
		//Gửi lên TCT
		SendToTCT: 2,
		//TCT đã duyệt
		TCTApproved: 3,
		//TCT không duyệt
		TCTRejected: 4,
		// Gửi TCT thất bại
		SendToTCTError: 5,
		// Ngân hàng đã duyệt
		BankApproved: 6,
		//Ngân hàng từ chối
		BankRejected: 7
	},
	/**
	 * Trạng thái của đăng kí dịch vụ
	 */
	MTaxStatusTextRegis: {
		/// Gửi lên MISA
		SendToMISA: 1,
		//Gửi lên TCT
		SendToTCT: 2,
		//TCT đã duyệt
		TCTApproved: 3,
		//TCT không duyệt
		TCTRejected: 4,
		// Gửi TCT thất bại
		SendToTCTError: 5,
		// Ngân hàng đã duyệt
		BankApproved: 6,
		//Ngân hàng từ chối
		BankRejected: 7
	},
	// Loại tờ khai
	TaxType: {
		//Cả khai và nộp
		None: 0,
		// Khai thuế
		TaxDec: 1,
		// Nộp thuế
		TaxPay: 2
	},
	TaxPaperFilterCode: {
		PaperPaymentCode: 0,
		SubmissionId: 1,
		BankPaymentCode: 2
	},
	// Bước trong quy trình cấp bù chứng thư số (khớp CompensCertStepEnum ở backend)
	CompensCertStep: {
		// Chưa hoàn thành bước nào
		None: 0,
		// Đã xác thực chứng thư số mới trên app MISA eSign
		VerifyEsign: 1,
		// Đã kết nối chứng thư số mới trên mTax
		ConnectCertificate: 2,
		// Đã lập và gửi tờ khai đăng ký sử dụng chứng thư số mới
		RegisterDeclaration: 3
	},
	TaxPaperPayerName: {
		PayerTaxAgentName: 0,
		PayerBankName: 1
	},
	TypeOfMoney: {
		VND: 1,
		USD: 2
	},
	TypeOrgAuthority: {
		StateAudit: 1,
		GovernmentInspector: 2,
		FinancialInspector: 3,
		OtherCompetentAuthority: 4
	},
	TaxPaperFilterDate: {
		PaperCreatedDate: 0,
		FilingDate: 1
	},
	/**
	 * Cơ quan thông báo
	 */
	AgencyNoti: {
		AgencyTax: 1,
		Bank: 2
	},
	/**
	 * Loại thông báo
	 */
	NotificationType: {
		RegisterService: 1,
		RegisterTax: 2,
		Decleration: 3,
		PAYMENT: 4,
		TaxRefund: 5
	},
	/**
	 * Trạng thái kết quả thông báo
	 */
	NotificationStatus: {
		None: 0, //Không làm gì
		TCTReceive: 1, //TCT tiếp nhận
		TCTNotReceive: 2, //TCT từ chối tiếp nhận
		TCTAccept: 3, //TCT chấp nhận, //Quyết định hoàn (28, 29)
		TCTReject: 4, //TCT từ chối chấp nhận
		BankAccept: 5, //Ngân hàng chấp nhận
		BankReject: 6, //Ngân hàng từ chối
		Error: 7, //Gửi TCT thất bại
		//Hoàn thuế
		TCTProcessingRefund: 8, //TCT đang xử lý hoàn thuế
		Cancel: 9, //TCT chấp nhận hủy cho hoàn thuế (46)
		RequestJustify: 10, //TCT yêu cầu giải trình, bổ sung hoàn thuế (23)
		Justified: 11, //NNT đã gửi giải trình, bổ sung hoàn thuế => Khi nộp lại phụ lục Click Hoàn thành giải trình bổ sung => Đổi trạng thái sang 10
		Paused: 12 //TCT tạm dừng giải quyết hoàn thuế (26)
	},
	/**
	 * Kết quả thông báo đăng ký dịch vụ
	 */
	NotificationStatusRegis: {
		None: 0, //Không làm gì
		TCTReceive: 1, //TCT tiếp nhận
		TCTNotReceive: 2, //TCT từ chối tiếp nhận
		TCTAccept: 3, //TCT chấp nhận, //Quyết định hoàn (28, 29)
		TCTReject: 4, //TCT từ chối chấp nhận
		BankAccept: 5, //Ngân hàng chấp nhận
		BankReject: 6, //Ngân hàng từ chối
		Error: 7, //Gửi TCT thất bại
		//Hoàn thuế
		TCTProcessingRefund: 8, //TCT đang xử lý hoàn thuế
		Cancel: 9, //TCT chấp nhận hủy cho hoàn thuế (46)
		RequestJustify: 10, //TCT yêu cầu giải trình, bổ sung hoàn thuế (23)
		Justified: 11, //NNT đã gửi giải trình, bổ sung hoàn thuế => Khi nộp lại phụ lục Click Hoàn thành giải trình bổ sung => Đổi trạng thái sang 10
		Paused: 12 //TCT tạm dừng giải quyết hoàn thuế (26)
	},
	KindLocation: {
		Province: 1,
		District: 2,
		Ward: 3
	},
	TypeTargetPayment: {
		Target7111: 0,
		Target8993: 1,
		Target3397: 2
	},
	TypeTax: {
		TaxInner: 1,
		TaxBefore: 2
	},
	TypeTaxPeriod: {
		PeriodDate: 1,
		PeriodMonth: 2,
		PeriodQuarter: 3,
		PeriodStage: 4,
		PeriodYear: 5,
		PeriodSetteYear: 6,
		PeriodSetteDate: 7
	},
	TypeContactAddional: {
		TaxDec: 1,
		TaxPay: 2,
		All: 3
	},
	Month: {
		Month1: 1,
		Month2: 2,
		Month3: 3,
		Month4: 4,
		Month5: 5,
		Month6: 6,
		Month7: 7,
		Month8: 8,
		Month9: 9,
		Month10: 10,
		Month11: 11,
		Month12: 12
	},
	Quarter: {
		Quarter1: 1,
		Quarter2: 2,
		Quarter3: 3,
		Quarter4: 4
	},
	Stage: {
		Stage1: 1,
		Stage2: 2
	},
	MisaId: errorMisaId,
	PromotionCode: {
		/// <summary>
		/// Mã KM đã không hợp lệ
		/// </summary>
		Promotion_Invalid: 101,

		/// <summary>
		/// Lỗi áp dụng 2 mã giảm giá khác loại
		/// </summary>
		Promotion_TypeOther: 102,

		/// <summary>
		/// Mã KM đã được sử dụng
		/// </summary>
		Promotion_Used: 103,

		/// <summary>
		/// Mã KM đã bị hủy
		/// </summary>
		Promotion_Destroyed: 104,

		/// <summary>
		/// Mã KM đã hết hạn
		/// </summary>
		Promotion_Expired: 105,

		/// <summary>
		/// Không đủ điều kiện áp dụng
		/// </summary>
		Promotion_NotEnough: 106,

		/// <summary>
		/// 1 gói sản phẩm chỉ được áp dụng 1 MGG
		/// </summary>
		Promotion_PackApplyCode: 107,

		/// <summary>
		/// Lỗi khi update trạng thái mgg
		/// </summary>
		ValidateError: 108,

		/// <summary>
		/// Mã xác thực captcha không chính xác
		/// </summary>
		Captcha_Invalid: 109,

		/// <summary>
		/// Lỗi exception không xử lí được thanh toán
		/// </summary>
		Exception: 110,

		/// <summary>
		/// Mã số thuế đã mua mtax
		/// </summary>
		TaxCodeExist: 111
	},
	StatusCode: {
		Status100Continue: 100,
		Status412PreconditionFailed: 412,
		Status413PayloadTooLarge: 413,
		Status413RequestEntityTooLarge: 413,
		Status414RequestUriTooLong: 414,
		Status414UriTooLong: 414,
		Status415UnsupportedMediaType: 415,
		Status416RangeNotSatisfiable: 416,
		Status416RequestedRangeNotSatisfiable: 416,
		Status417ExpectationFailed: 417,
		Status418ImATeapot: 418,
		Status419AuthenticationTimeout: 419,
		Status421MisdirectedRequest: 421,
		Status422UnprocessableEntity: 422,
		Status423Locked: 423,
		Status424FailedDependency: 424,
		Status426UpgradeRequired: 426,
		Status428PreconditionRequired: 428,
		Status429TooManyRequests: 429,
		Status431RequestHeaderFieldsTooLarge: 431,
		Status451UnavailableForLegalReasons: 451,
		Status500InternalServerError: 500,
		Status501NotImplemented: 501,
		Status502BadGateway: 502,
		Status503ServiceUnavailable: 503,
		Status504GatewayTimeout: 504,
		Status505HttpVersionNotsupported: 505,
		Status506VariantAlsoNegotiates: 506,
		Status507InsufficientStorage: 507,
		Status508LoopDetected: 508,
		Status411LengthRequired: 411,
		Status510NotExtended: 510,
		Status410Gone: 410,
		Status408RequestTimeout: 408,
		Status101SwitchingProtocols: 101,
		Status102Processing: 102,
		Status200OK: 200,
		Status201Created: 201,
		Status202Accepted: 202,
		Status203NonAuthoritative: 203,
		Status204NoContent: 204,
		Status205ResetContent: 205,
		Status206PartialContent: 206,
		Status207MultiStatus: 207,
		Status208AlreadyReported: 208,
		Status226IMUsed: 226,
		Status300MultipleChoices: 300,
		Status301MovedPermanently: 301,
		Status302Found: 302,
		Status303SeeOther: 303,
		Status304NotModified: 304,
		Status305UseProxy: 305,
		Status306SwitchProxy: 306,
		Status307TemporaryRedirect: 307,
		Status308PermanentRedirect: 308,
		Status400BadRequest: 400,
		Status401Unauthorized: 401,
		Status402PaymentRequired: 402,
		Status403Forbidden: 403,
		Status404NotFound: 404,
		Status405MethodNotAllowed: 405,
		Status406NotAcceptable: 406,
		Status407ProxyAuthenticationRequired: 407,
		Status409Conflict: 409,
		Status511NetworkAuthenticationRequired: 511
	},
	ServiceStatusCode: {
		Status03NotUpgradeAccount: 3, // Tài khoản chưa nâng cấp lên MISAID
		Status04HasNotAccount: 4, // Chưa có tài khoản
		Status05HasNotRegistrationTvan: 5, // Chưa đăng ký TVAN
		Status06NotPermittedAccess: 6, // Tài khoản không có quyền truy cập dữ liệu
		Status07InvalidClient: 7, // Không cho phép client_id này vào hệ thống
		Status08InvalidInputRequest: 8, // Tham số đầu vào không hợp lệ
		Status09RoleOnly: 9, // Quyền quản trị duy nhất
		Status11InvalidAdminAccess: 11, // Chỉ cho người dùng có quyền admin thao tác
		Status13InvalidTaxCode: 13, //Cảnh báo MST làm việc khác với MST trong tờ khai(Không phải tờ khai nộp thay)
		Status14UnregisterDeclaration: 14, //Tờ khai chưa đăng ký nộp qua mạng
		Status16FirstDeclareHasNotBeenAccepted: 16, //Tờ khai nộp lần đầu chưa được chấp nhận
		Status18UnexpiredAdditional: 18, //Lỗi chưa hết hạn nộp tờ khai nhưng lại nộp tờ khai bổ sung
		Status19ExpiredDeclaration: 19, //Qúa hạn kê khai
		Status20ExistDeclarationAdditional: 20, //Đã có tờ khai bổ sung
		Status21RequiredDeclarationAdditional: 21, //Cần nộp tờ khai bổ sung
		Status24TaxAuthoritiesother: 24, //Mã cơ quan thuế trong tờ khai khác mã cqt NNT
		Status27MaintainSystem: 27, //Đang nâng bảo trì hệ thống
		Status31InvalidDeclareTaxCodePaidInstead: 31, //Cảnh báo mst đang làm việc khác với MST trong tờ khai(Tờ khai nộp thay)
		Status32UnregisterDeclaration: 32, //Tờ khai chưa đăng ký nộp qua mạng
		Status48AdminSystemFromAmis: 48 /// Quyền quản trị hệ thống AMIS
	},
	Authorized: {
		NonAuthorized: 0, //Giấy nộp tiền,
		IsAuthorized: 1 //Giấy nộp tiền thay thế,
	},
	/**
	 * Loại kê khai: Tờ khai / phụ lục
	 */
	TaxReturnTypeEnum: {
		PrimaryReport: 1,
		AdditionalReport: 2
	},
	/**
	 * Kỳ kê khai
	 */
	PeriodTypeEnum: {
		PeriodMonth: 1,
		PeriodQuarter: 2,
		PeriodIncurred: 3,
		PeriodYear: 4,
		SettlementYear: 5,
		PeriodStage: 6
	},
	TaxReturnSubmissionFilterOptions: {
		TaxPeriod: 'TaxPeriod',
		CreatedDate: 'CreatedDate'
	},
	TaxReturnSubmissionIsPaidFilters: {
		Date: 'Date',
		TaxReturnParentCode: 'TaxReturnParentCode',
		IsOnlyViewTaxReturnHaveToPaidTax: 'IsOnlyViewTaxReturnHaveToPaidTax'
	},
	TaxPaymentStatusEnum: {
		/// Không nộp thuế
		NOPAYTAX: 0,
		/// Chưa nộp thuế
		HAVENOTPAIDTAX: 1,
		/// Đã nộp một phần
		PAIDTAXAPART: 2,
		/// Đã nộp thuế
		PAIDTAXFULL: 3
	},
	FinanceYearStartDateEnum: {
		FirstDayOfYear: 1,
		FirstDayOfTheFirstQuarter: 2,
		FirstDayOfTheSecondQuarter: 3,
		FirstDayOfTheThirdQuarter: 4
	},
	//File của chứng từ nào
	FileType: {
		Taxreturn: 1,
		Payment: 2,
		Notification: 3,
		TaxReturnSubmission: 4,
		TaxReturnRegisHistory: 5,
		ServiceRegisHistory: 6
	},
	//Định dạng file
	FileFormat: {
		Pdf: 1,
		Xml: 2
	},
	/*
	 * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
	 */
	Period: {
		ThisDay: 20,
		ThisWeek: 30,
		FirstWeekToPresent: 31,
		ThisMonth: 45,
		FirstMonthToPresent: 46,
		ThisQuarter: 60,
		FirstQuarterToPresent: 61,
		ThisYear: 500,
		FirstYearToPresent: 501,
		SixFirstMonth: 75,
		SixLastMonth: 70,
		//Các tháng trong năm
		January: 1,
		February: 2,
		March: 3,
		April: 4,
		May: 5,
		June: 6,
		July: 7,
		August: 8,
		September: 9,
		October: 10,
		November: 11,
		December: 12,
		//Qúy
		FiscalI: 100, //Qúy 1
		FiscalII: 200,
		FiscalIII: 300,
		FiscalIV: 400,

		Yesterday: 21,
		LastWeek: 35,
		LastMonth: 50,
		LastQuarter: 65,
		LastYear: 80,

		Tomorrow: 25,
		NextWeek: 40,
		NextMonth: 55,
		NextQuarter: 66,
		NextYear: 90,

		Custom: 0
	},
	/*
	 * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
	 */
	SimplePeriod: {
		ThisDay: 20,
		ThisWeek: 30,
		ThisMonth: 45,
		ThisQuarter: 60,
		ThisYear: 500,
		Yesterday: 21,
		LastWeek: 35,
		LastMonth: 50,
		FiscalI: 100, //Qúy 1
		FiscalII: 200,
		FiscalIII: 300,
		FiscalIV: 400,
		LastYear: 80,
		Custom: 0
	},
	SortStatus: {
		none: 0,
		desc: 1,
		asc: 2
	},
	ContactType: {
		DECLERATION: 1,
		PAYMENT: 2,
		ALL: 0
	},
	/**
	 * Lỗi validate tờ khai
	 */
	ErrorValidateDec: {
		ErrorRegistrationDeclare: 101,
		ErrorStopDeclare: 102
	},
	/**
	 * Lỗi chi tiết tờ khai
	 */
	ErrorDetailDec: {
		/// <summary>
		/// Trùng tờ khai
		/// </summary>
		IdenticalDec: 111,
		/// <summary>
		/// Tờ khai không được đăng ký cùng lúc tháng và quý
		/// </summary>
		MonthQuarter: 112
	},

	/**
	 * Loại thay đổi khi thay đổi thông tin đăng ký sử dụng
	 */
	TypeChangeRegis: {
		None: 0, //Thay đổi cả chữ ký số và thông tin liên hệ
		Sign: 1, //Thay đổi chữ ký số
		Contact: 2 //Thay đổi thông tin liên hệ
	},
	TypeHasRegister: {
		None: 0,
		TCT: 1,
		Other: 2
	},
	/**
	 * Loại tờ khai: Lần đầu/ Bổ sung
	 */
	DeclareSubmissionType: {
		First: 1, //Lần đầu
		Additional: 2 //Bổ súng
	},
	/**
	 * Loại kết dịch vụ: 1-Khai thuế, 2-Nộp thuế
	 */
	TypeServiceTvanEnum: {
		DECLERATION: 1,
		PAYMENT: 2
	},
	/**
	 * Loại thỏa thuận sử dụng
	 */
	AgreementType: {
		TermsOfService: 1, //Thỏa thuận sử dụng dịch vụ
		Privacy: 2, // Chính sách quyền riêng tư
		All: 3 // Cả Thỏa thuận sử dụng dịch vụ và Chính sách quyền riêng tư
	},
	/**
	 * Phương thức thanh toán
	 */
	PaymentMethod: {
		Visa: 2,
		ATM: 1,
		PaymentProvider: 3,
		Tranfers: 4,
		Paypal: 5,
		JeyPay: 6,
		Free: 100
	},
	/**
	 * Trạng thái thanh toán
	 */
	PaymentStatusEnum: {
		New: 0, //Mới
		Wait: 1, //Chờ thanh toán
		Success: 3, //Đã thanh toán
		Cancel: 4 //Đã hủy
	},
	OrderEnum: order,
	/**
	 * Loại sản phẩm
	 */
	SoftwareEnum: {
		Mtax: 0,
		Esign: 1
	},
	OptionTypeEnum: {
		NotificationIsReceived: 1,
		WarningSettings: 2
	},
	/**
	 * Thời gian khi xem dasboard số thuế đã nộp
	 */
	TimesTaxPaidEnum: {
		Full: 0,
		ThreeYear: 3,
		FiveYear: 5
	},
	/**
	 * Loại xem dasboard thuế đã nộp
	 */
	ChartTypeEnum: {
		TypeTime: 1, //Theo thời gian
		TypeTax: 2 //Theo loại thuế đã nộp
	},
	/**
	 * Thời gian xem theo kỳ ở dasboard thuế đã nộp
	 */
	SeePeriodEnum: {
		Month: 1, //Tháng
		Quarter: 2, //QUý
		Year: 3 //Năm
	},
	GroupTypeEnum: {
		Other: 0, // Khác
		QuyetToanTNCN: 1, //Quyết toán thu nhập cá nhân
		BaoCaoAnChi: 2, //Báo cáo ấn chỉ
		HoanThue: 3 //Hoàn thuế
	},
	/**
	 * Loại thuế
	 */
	TaxableTypeEnum: {
		Other: 0, //Khác (1-1)
		PersonalIncome: 1, //Thu nhâp cá nhân tổng(2-1)
		ForeignContractor: 2, //Nhà thầu nước ngoài (2-2)
		SpecialConsumption: 3, //Tiêu thụ đặc biệt (n-n)
		TaxProtectEnvironment: 4, //Thuế bảo vệ môi trường (n-n)
		FeesProtectEnvironment: 5, //Phí bảo vệ môi trường (n-n)
		FeesAndCharges: 6, //Phí, lệ phí
		Resources: 7, //Tài nguyên
		GTGT: 8 //Giá trị gia tăng (01)
	},

	/**
	 * Loại thuế chi tiết: Loại thuế của các tờ khai không mapping theo sản phẩm)
	 */
	TaxTypeEnum: {
		VAT: 1, // Thuế giá trị gia tăng
		Income: 2, // Thuế thu nhập doanh nghiệp
		PersonalIncome: 3 // Thuế thu nhập cá nhân
	},

	// Đầu mục thuế
	ParentTaxReturn: {
		TaxReturnNTNN: 43, // Thuế Nhà thầu nước ngoài (NTNN)
		TaxReturnCTTS: 67 // Tờ khai đối với hoạt động cho thuê tài sản
	},

	// Các tờ khai thuộc loại GNT nộp thay
	IsAuthorizedTaxReturn: {
		TaxReturn01NTNN: '01/NTNN',
		TaxReturn02NTNN: '02/NTNN',
		TaxReturn01TTS: '01/TTS'
	},

	IsOnlyViewTaxReturnHaveToPaidTax: {
		isChecked: 1
	},

	EventFilter: {
		ReFilter: 1,
		ClearFilter: 2,
		UnFilter: 3,
		DoFilter: 4
	},
	DirectPage: {
		None: 0,
		RegisTaxPay: 1,
		HistoryRegis: 2,
		RegisTaxDec: 3,
		RegisTaxReturn: 4,
		RegisStopTaxReturn: 5,
		RegisTaxReghaunt: 6,
		RegisStopTaxReghaunt: 7,
		HistoryRegisTaxReturn: 8,
		HistoryRegisTaxReghaunt: 9,
		ProcessTaxReturn: 10,
		ProcessTaxPay: 11,
		TaxPayerInfo: 12,
		UserManager: 13,
		AddBank: 14,
		ChangeTaxDec: 15,
		ChangeTaxPay: 16,
		ContactAdditional: 17,
		ServiceTVAN: 18
	},
	TaxReturnRegisType: {
		All: 0, //Lấy tất cả
		TaxAgent: 1, //Chỉ lấy tờ khai theo CQT quản lý
		Haunt: 2 //Lấy tờ khai đăng ký vãng lai
	},
	DocumentType: {
		Pdf: 0,
		Xml: 1,
		Hash: 2,
		Excel: 3,
		Word: 4,
		XmlIVan: 5,
		XmlIMTax: 6,
		DecTaxReturn: 7,
		SignString: 8,
		PdfIVan: 9,
		PdfES: 10,
		XpathIntersect: 11
	},
	ReasonType: {
		ProductNotGood: 1, // Sản phẩm không đáp ứng nhu cầu
		ProductError: 2, // Sản phẩm hay bị lỗi
		SupportServiceNotGood: 3, // Dịch vụ tư vấn hỗ trợ khách hàng kém
		HighPrice: 4, // Giá thành cao
		UseConvenient: 5, // Thao tác sử dụng không thuận tiện
		SlowProcessingSpeed: 6, // Tốc độ xử lý chậm
		SecurityNotGood: 7, // Bảo mật phần mềm kém
		ReasonOther: 0 // Lý do khác
	},

	/**
	 * Phân biệt dữ liệu theo quy định luật thuế
	 * Sử dụng để xác định luồng xử lý theo quy định cũ hay mới (Luật 72/2025)
	 */
	TaxRegulationType: {
		/**
		 * Dữ liệu theo quy định cũ (trước Luật 72/2025)
		 */
		Legacy: 0,

		/**
		 * Dữ liệu theo Luật 72/2025
		 */
		Law72_2025: 1
	},

	/**
	 * Loại người nộp thuế
	 */
	TaxpayerInfoType: {
		Organization: 1, //Doanh nghiệp
		Individual: 2, // Hộ kinh doanh
		SoleTrader: 3 // Cá nhân kinh doanh (mới)
	},

	/**
	 * Trạng thái chuyển đổi dữ liệu khách hàng từ MTAX sang AMIS Platform
	 */
	AmisConvertStatus: {
		NotConverted: 0, // Chưa chuyển đổi
		Processing: 1, // Đang xử lý
		Converted: 2, // Đã chuyển đổi thành công
		Failed: 3, // Thất bại
		MutilTenant: 4, // MST có nhiều công ty (tenant) trên AMIS Platform, không thể chuyển đổi tự động
		TenantInstalled: 5, // Đã cài đặt công ty AMIS Platform thành công (bước 1)
		AppInstalled: 6, // Đã cài đặt app MTAX cho công ty thành công (bước 1.5)
		UsersSynced: 7, // Đã đồng bộ toàn bộ user lên AMIS thành công (bước 1.6)
		NoResource: 8, // Hết tài nguyên — không có license hợp lệ từ Suman (hết hạn hoặc chưa cấp phát)
		AppNamesWithLicenseEmpty: 9, // Danh sách app code có license bên AMIS không có
		UserInAmisInActiveOrTrash: 10, // User thực hiện convert dữ liệu ở danh sách người dùng của công ty định convert trên AMIS bị ngừng kích hoạt hoặc ở thùng rác
		ConvertedAndSeenNotification: 11 // Đã chuyển đổi thành công và đã xem thông báo nâng cấp
	},

	/**
	 * Trạng thái kích hoạt từ AMIS Platform
	 */
	AmisActiveStatus: {
		Init: 0, // Mặc định — chưa kích hoạt qua AMIS Platform
		Active: 1 // Đã kích hoạt qua AMIS Platform
	},

	/**
	 * Loại giấy nộp tiền (GNT)
	 * Phân biệt theo quy định Thông tư 84 hay Nghị định 11
	 */
	TaxPaperType: {
		/**
		 * Giấy nộp tiền theo Thông tư 84/2019/TT-BTC
		 */
		Circular84: 0,

		/**
		 * Giấy nộp tiền theo Nghị định 11/2020/NĐ-CP
		 */
		Decree11: 1,

		/// <summary>
		/// Thông tư 110/TT-BTC ngày 28/07/2015 (Mặc định - Dữ liệu cũ)
		/// </summary>
		/// <remarks>
		/// Áp dụng cho các đăng ký dịch vụ TVAN trước ngày 18/3/2021
		/// </remarks>
		Circular_110_2015: 2,

		/// <summary>
		/// Thông tư 19/2021/TT-BTC ngày 18/3/2021 (Dữ liệu mới)
		/// </summary>
		/// <remarks>
		/// Áp dụng cho các đăng ký dịch vụ TVAN từ ngày 18/3/2021 trở đi
		/// Có thêm cột "NHÂN VIÊN ĐẠI LÝ THUẾ" trong footer
		/// </remarks>
		Circular_19_2021: 3
	},

	/**
	 * Trạng thái của quá trình xuất khẩu file
	 * Map với ExportStatusEnum.cs ở backend
	 * Created by hvanh on 09/02/2026
	 */
	ExportStatusEnum: {
		/**
		 * Đang xử lý xuất khẩu (backend đang build file)
		 * Map với ExportStatusEnum.Processing = 0
		 */
		Processing: 0,

		/**
		 * Xuất khẩu hoàn thành (file đã được upload lên MinIO)
		 * Map với ExportStatusEnum.Completed = 1
		 */
		Completed: 1,

		/**
		 * Xuất khẩu lỗi (có lỗi xảy ra trong quá trình xử lý)
		 * Map với ExportStatusEnum.Error = 2
		 */
		Error: 2,

		NotExistsFile: 3
	},

	/**
	 * Trạng thái của download task UI (chỉ dùng cho frontend)
	 * Bao gồm cả trạng thái "Downloading" khi file đang được download về client
	 */
	DownloadTaskStatus: {
		/**
		 * Đang xử lý (backend đang build file)
		 * Tương ứng với ExportStatusEnum.Processing
		 */
		Processing: 0,

		/**
		 * Đang tải xuống (file đã sẵn sàng trên MinIO, đang download về client)
		 * Trạng thái này chỉ tồn tại ở frontend
		 */
		Downloading: 1,

		/**
		 * Hoàn thành (file đã được download thành công)
		 * Tương ứng với ExportStatusEnum.Completed (sau khi download xong)
		 */
		Completed: 2,

		/**
		 * Lỗi (có lỗi xảy ra trong quá trình xử lý hoặc download)
		 * Tương ứng với ExportStatusEnum.Error
		 */
		Error: 3
	},

	/**
	 * Trạng thái của phiên ký số từ xa (async mode)
	 * Map với SigningStatusEnum.cs ở backend — serialize thành số nguyên
	 * Created by HVANH on 10/03/2026
	 */
	SigningStatusEnum: {
		/**
		 * Đang chờ xác nhận — phiên ký vừa được khởi tạo, chưa xử lý
		 * Map với SigningStatusEnum.Pending = 0
		 */
		Pending: 0,

		/**
		 * Đang xử lý — đã nhận xác nhận, đang gắn chữ ký
		 * Map với SigningStatusEnum.Processing = 1
		 */
		Processing: 1,

		/**
		 * Ký thành công — file đã ký sẵn sàng để lấy về
		 * Map với SigningStatusEnum.Success = 2
		 */
		Success: 2,

		/**
		 * Ký thất bại — có lỗi xảy ra trong quá trình ký
		 * Map với SigningStatusEnum.Failed = 3
		 */
		Failed: 3,

		/**
		 * Hết thời gian chờ — người dùng không xác nhận trong thời gian quy định
		 * Map với SigningStatusEnum.Timeout = 4
		 */
		Timeout: 4,

		/**
		 * Không tìm thấy — phiên ký không tồn tại hoặc đã hết hạn cache
		 * Map với SigningStatusEnum.NotFound = 5
		 */
		NotFound: 5
	},

	/**
	 * Nguồn danh sách phụ lục đính kèm khi nộp tờ khai
	 */
	AttachmentSource: {
		/**
		 * Danh sách từ cổng Dịch vụ công (DVC) — hiển thị theo TaxReturnName
		 */
		DVC: 1,

		/**
		 * Danh sách từ cổng eTax — hiển thị theo DisplayName
		 */
		ETax: 2
	}
};
